import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmModal = ({ open, onClose, onConfirm, title = "آیا مطمئن هستید؟", message = "آیا می‌خواهید خارج شوید؟" }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{fontSize:'16px' , display:'flex' , alignItems:'center' , gap:'8px'}}>
        <img src='./assets/images/alert-danger.svg' alt='' style={{width:'24px' , height:'24px'}}/>
        {title}
        </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{fontSize:'14px'}}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{gap:'16px'}}>
        <Button onClick={onClose} color="inherit" sx={{fontSize:'12px'}}>لغو</Button>
        <Button onClick={onConfirm} color="error" variant="contained" sx={{fontSize:'12px'}}>خروج</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
